function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useMemo, useState } from 'react';
import { DownOutlined, LeftOutlined, RightOutlined } from '@aelf-design/icons';
import { Select } from 'antd';
import { debounce } from 'lodash-es';
import Button from "../Button";
import useStyles from "./style";
export default function Pagination(_ref) {
  var current = _ref.current,
    _ref$pageSize = _ref.pageSize,
    pageSize = _ref$pageSize === void 0 ? 10 : _ref$pageSize,
    _ref$defaultCurrent = _ref.defaultCurrent,
    defaultCurrent = _ref$defaultCurrent === void 0 ? 1 : _ref$defaultCurrent,
    _ref$defaultPageSize = _ref.defaultPageSize,
    defaultPageSize = _ref$defaultPageSize === void 0 ? 10 : _ref$defaultPageSize,
    total = _ref.total,
    _ref$showSizeChange = _ref.showSizeChange,
    showSizeChange = _ref$showSizeChange === void 0 ? true : _ref$showSizeChange,
    _ref$showLast = _ref.showLast,
    showLast = _ref$showLast === void 0 ? true : _ref$showLast,
    _ref$showFirst = _ref.showFirst,
    showFirst = _ref$showFirst === void 0 ? true : _ref$showFirst,
    _ref$showSizeChanger = _ref.showSizeChanger,
    showSizeChanger = _ref$showSizeChanger === void 0 ? true : _ref$showSizeChanger,
    hideOnSinglePage = _ref.hideOnSinglePage,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [10, 20, 50] : _ref$options,
    pageChange = _ref.pageChange,
    onChange = _ref.onChange,
    pageSizeChange = _ref.pageSizeChange;
  // Component state
  var _useState = useState(defaultCurrent),
    _useState2 = _slicedToArray(_useState, 2),
    pageNum = _useState2[0],
    setPageNum = _useState2[1];
  var _useState3 = useState(defaultPageSize),
    _useState4 = _slicedToArray(_useState3, 2),
    pageSizeValue = _useState4[0],
    setPageSizeValue = _useState4[1];

  // Calculated states
  var totalPage = Math.floor((total + pageSizeValue - 1) / pageSizeValue) || 1;
  var isFirstPage = pageNum === 1;
  var isLastPage = pageNum >= totalPage;

  // Hooks
  var _useStyles = useStyles(),
    styles = _useStyles.styles,
    cx = _useStyles.cx,
    prefixCls = _useStyles.prefixCls;

  // Effect
  useEffect(function () {
    if (current) {
      setPageNum(current);
    }
  }, [current]);
  useEffect(function () {
    if (pageSize) {
      setPageSizeValue(pageSize);
    }
  }, [pageSize]);

  // Methods
  var prevChange = function prevChange() {
    var page = pageNum === 1 ? pageNum : pageNum - 1;
    setPageNum(page);
    pageChange === null || pageChange === void 0 || pageChange(page);
    onChange === null || onChange === void 0 || onChange(page, pageSizeValue);
  };
  var runPrevChange = debounce(prevChange, 300, {
    leading: true,
    trailing: false
  });
  var nextChange = function nextChange() {
    var page = pageNum === totalPage ? totalPage : pageNum + 1;
    setPageNum(page);
    pageChange === null || pageChange === void 0 || pageChange(page);
    onChange === null || onChange === void 0 || onChange(page, pageSizeValue);
  };
  var runNextChange = debounce(nextChange, 300, {
    leading: true,
    trailing: false
  });
  var jumpFirst = function jumpFirst() {
    setPageNum(1);
    pageChange === null || pageChange === void 0 || pageChange(1, pageSizeValue);
    onChange === null || onChange === void 0 || onChange(1, pageSizeValue);
  };
  var debounceJumpFirst = debounce(jumpFirst, 300, {
    leading: true,
    trailing: false
  });
  var jumpLast = function jumpLast() {
    setPageNum(totalPage);
    pageChange === null || pageChange === void 0 || pageChange(totalPage, pageSizeValue);
    onChange === null || onChange === void 0 || onChange(totalPage, pageSizeValue);
  };
  var debounceJumpLast = debounce(jumpLast, 300, {
    leading: true,
    trailing: false
  });
  var sizeChange = function sizeChange(value) {
    setPageNum(1);
    setPageSizeValue(value);
    pageSizeChange === null || pageSizeChange === void 0 || pageSizeChange(1, value);
    onChange === null || onChange === void 0 || onChange(1, value);
  };
  var pagesizeOptions = useMemo(function () {
    return options.map(function (item) {
      return {
        label: item,
        value: item
      };
    });
  }, [options]);

  // hidden pagination Render
  if (hideOnSinglePage && total <= options[0]) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.paginationContainer, prefixCls + '-pagination-container')
  }, /*#__PURE__*/React.createElement("div", null, showSizeChange && showSizeChanger && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: cx(styles.pagesizeLabel, prefixCls + '-pagesize-label')
  }, "Show\uFF1A"), /*#__PURE__*/React.createElement(Select, {
    defaultValue: pageSizeValue,
    value: pageSizeValue,
    className: styles.pagesizeSelect,
    popupClassName: styles.pageSizePopup,
    popupMatchSelectWidth: false,
    suffixIcon: /*#__PURE__*/React.createElement(DownOutlined, null),
    options: pagesizeOptions,
    onChange: sizeChange
  }), /*#__PURE__*/React.createElement("span", {
    className: cx(styles.pagesizeLabel, styles.records, prefixCls + '-pagesize-label')
  }, "Records"))), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.pageContainer, prefixCls + '-page-container')
  }, showFirst && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    disabled: isFirstPage,
    size: "small",
    className: cx(styles.paginationButton, prefixCls + '-pagination-button'),
    type: "primary",
    ghost: true,
    onClick: debounceJumpFirst
  }, "First")), /*#__PURE__*/React.createElement("div", {
    className: cx(prefixCls + '-pagination-first-button')
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: isFirstPage,
    type: "primary",
    className: cx(styles.paginationButton, prefixCls + '-pagination-button'),
    size: "small",
    ghost: true,
    onClick: runPrevChange,
    icon: /*#__PURE__*/React.createElement(LeftOutlined, null)
  })), /*#__PURE__*/React.createElement("div", {
    className: cx(prefixCls + '-pageNumber-container', styles.pageNumberContainer)
  }, /*#__PURE__*/React.createElement("div", null, "Page ".concat(current || pageNum, " of ").concat(totalPage))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    className: cx(styles.paginationButton, prefixCls + '-pagination-button'),
    size: "small",
    ghost: true,
    disabled: isLastPage,
    onClick: runNextChange,
    icon: /*#__PURE__*/React.createElement(RightOutlined, null)
  })), showLast && /*#__PURE__*/React.createElement("div", {
    className: cx(prefixCls + '-pagination-last-button')
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: isLastPage,
    className: cx(styles.paginationButton, prefixCls + '-pagination-button'),
    type: "primary",
    size: "small",
    ghost: true,
    onClick: debounceJumpLast
  }, "Last"))));
}